export enum SegmentKind {
  AirHandlingUnits = "AirHandlingUnits",
  Ductwork = "Ductwork",
  Extras = "Extras",
}

// The order is intentional, it reflects the common approach
// when collecting treatments
export const SegmentKindList = [
  SegmentKind.AirHandlingUnits,
  SegmentKind.Ductwork,
  SegmentKind.Extras,
];
